export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 102,
};

export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 64,
  H_DESKTOP_OFFSET: 80 - 16,
};

export const paths = {
  home: '/',
  orders: '/orders',
  lenders: '/lenders',
  vendors: '/vendors',
  reports: '/reports',
  allocations: '/allocation',
  admin: '/admin',
  group: {
    root: `/group`,
    five: `/group/five`,
    six: `/group/six`,
  },
};

export const usStates = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
];

export const attrTypes: Record<string, string> = {
  eNoteIndicator: 'E-note indicator',
  eClosingType: 'E-closing type',
  remoteOnlineNotarizationIndicator: 'RON',
  comment: 'Comment',
  contacts: 'Contacts',
  responsibleParty: 'Responsible Party',
  providerOrderId: 'Provider Order ID',
  closingLocationType: 'Closing Location Type',
  closingAddress: 'Closing Address',
  reasons: 'Reasons',
  reasonCode: 'Reason Code',
  reasonCodeDescription: 'Reason Description',
  reasonComment: 'Reason Comment',
  closingDatetime: 'Closing Date / Time',
  closingTimezone: 'Closing Timezone',
  fulfillmentCenter: 'Fulfillment Center',
  productName: 'Product Name',
  productCategory: 'Product Category',
  productPrice: 'Product Price',
  vendorName: 'Vendor Name',
  vendorOrganizationCode: 'Vendor Organization Code',
  vendorClientCode: 'Vendor Client Code',
  lenderName: 'Lender Name',
  lenderOrganization: 'Lender Organization',
  lenderOrganizationCode: 'Lender Organization Code',
  deedPageCount: 'Deed Page Count',
  mortgagePageCount: 'Mortgage Page Count',
  scheduledDate: 'Scheduled Date',
  scheduledTime: 'Scheduled Time',
};
